import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { VeterinarianService } from '@pxl/models/contracts';
import { AppointmentRoutingRouteNames, AppRoutingRouteNames } from '@pxl/route-names';
import { VeterinarianModel } from '@pxl/shared/generated';

export const vetResolver: ResolveFn<VeterinarianModel | undefined> = async (route) => {
    const router = inject(Router);
    const vetId = route.params[AppointmentRoutingRouteNames.VetIdParam];
    let vet: VeterinarianModel | undefined;
    vet = await inject(VeterinarianService)
        .getVeterinarian(vetId)
        .catch(() => undefined as never);
    if (!vet) {
        await router.navigate([AppRoutingRouteNames.Error]);
        return undefined;
    }
    return vet;
};
